<div class="logo-wrapper">
  <a routerLink="/" title="torna alla prima pagina di Teleforum"><img src="img/logo.png" id="logo" alt="Teleforum"></a>
</div>
<div class="forbidden-wrapper">
  <div class="status">Attenzione</div>
  <p>La tua sessione è scaduta o non è più valida. Premi "Aggiorna sessione" per tentare di rinnovarla.</p>
  <button class="btn btn-primary" (click)="onAggiornaSessione()"> Aggiorna Sessione </button>
</div>